"use client";
import { useId, useState } from "react";
import styles from "./IntegrationExperience.module.scss";
export function WorkflowCard({ copy, scenario }) {
 return <div className={styles.workflowCard}>
  <div className={styles.message}><span className={styles.eyebrow}>{copy["scenarios.customer"]}</span><p>{scenario.question}</p><span className={styles.messageDots} aria-hidden="true">•••</span></div>
  <div className={styles.workflowSteps}>{["source", "action", "result"].map((key, index) => <div className={styles.workflowStep} key={key}>
   <span className={styles.stepNumber} aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
   <div><h3>{copy["scenarios." + key]}</h3><p>{scenario[key]}</p></div>
  </div>)}</div>
 </div>;
}
export default function IntegrationScenarios({ copy }) {
 const [active, setActive] = useState(0);
 const id = useId();
 const scenarios = ["order", "stock", "request"].map(key => ({
  key, label: copy["scenarios." + key + ".label"], question: copy["scenarios." + key + ".question"],
  source: copy["scenarios." + key + ".source"], action: copy["scenarios." + key + ".action"], result: copy["scenarios." + key + ".result"],
 }));
 return <section className={styles.scenarios} aria-labelledby={id + "-heading"}><div className={styles.wrap}>
  <div className={styles.sectionHeading}><span className={styles.eyebrow}>{copy["scenarios.label"]}</span><h2 id={id + "-heading"}>{copy["scenarios.title"]}</h2><p>{copy["scenarios.description"]}</p></div>
  <div className={styles.tabs} role="tablist" aria-label={copy["scenarios.title"]}>
   {scenarios.map((scenario, index) => <button key={scenario.key} type="button" role="tab"
    id={id + "-tab-" + index} aria-controls={id + "-panel-" + index} aria-selected={active === index} tabIndex={active === index ? 0 : -1}
    onClick={() => setActive(index)} onKeyDown={event => {
     const next = event.key === "Home" ? 0 : event.key === "End" ? 2 : event.key === "ArrowRight" ? (active + 1) % 3 : event.key === "ArrowLeft" ? (active + 2) % 3 : null;
     if (next !== null) { event.preventDefault(); setActive(next); document.getElementById(id + "-tab-" + next)?.focus(); }
    }}><span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>{scenario.label}</button>)}
  </div>
  {scenarios.map((scenario, index) => <div key={scenario.key} id={id + "-panel-" + index} role="tabpanel"
   aria-labelledby={id + "-tab-" + index} hidden={active !== index} tabIndex={0}><WorkflowCard copy={copy} scenario={scenario} /></div>)}
 </div></section>;
}
